import { confirmAlert } from "react-confirm-alert";
import { PageContainer } from "../PageContainer";
import { Button, Divider, TextField } from "@mui/material";
import {
  DELETE_EDITION_AND_EVERYTHING,
  DELETE_EDITION_BOOKINGS,
  IMPORT_CLASHFINDER_EDITION,
} from "./graphql";
import { toast } from "react-toastify";
import { useMutation } from "@apollo/client";
import { GET_EDITIONS } from "../../routes/editions/graphql";
import { useState } from "react";

export const Importer = () => {
  const [editionId, setEditionId] = useState("");
  const [clashfinderUrl, setClashfinderUrl] = useState("");

  const [importClashfinderEdition] = useMutation(IMPORT_CLASHFINDER_EDITION, {
    onCompleted: () => {
      toast("Edition added");
    },
    onError: (err) => toast(JSON.stringify(err)),
    refetchQueries: [GET_EDITIONS],
  });

  const [deleteEditionBookings, { loading: updateLoading, error }] =
    useMutation(DELETE_EDITION_BOOKINGS, {
      onCompleted: () => {
        toast("Edition bands removed");
      },
      onError: (err) => toast(JSON.stringify(err)),
      refetchQueries: [GET_EDITIONS],
    });

  const handleImport = () => {
    importClashfinderEdition({ variables: { url: clashfinderUrl } });
  };

  const handleDelete = () => {
    confirmAlert({
      title: "Delete edition?",
      message:
        "This removes the edition and all bookings ... Are you sure? this can't be undone",
      buttons: [
        {
          label: "Yes",
          onClick: () =>
            deleteEditionBookings({ variables: { editionId } }),
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };
  return (
    <PageContainer title="Importer">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 12,
          width: "50%",
        }}
      >
        <TextField
          id="outlined-basic"
          label="Clashfinder name"
          variant="outlined"
          defaultValue={""}
          fullWidth={false}
          value={clashfinderUrl}
          onChange={(value) => {
            setClashfinderUrl(value.target.value);
          }}
        />
        {/* @ts-ignore */}
        <Button
          disabled={!clashfinderUrl}
          variant="contained"
          onClick={handleImport}
          style={{ backgroundColor: "red", maxWidth: 250 }}
        >
          Import Clashfinder Edition
        </Button>
        <Divider style={{marginTop: 60, marginBottom: 60}}/>
        <TextField
          id="outlined-basic"
          label="Edition Id"
          variant="outlined"
          defaultValue={""}
          fullWidth={false}
          value={editionId}
          onChange={(value) => {
            setEditionId(value.target.value);
          }}
        />
        {/* @ts-ignore */}
        <Button
          disabled={!editionId}
          variant="contained"
          onClick={handleDelete}
          style={{ backgroundColor: "red", maxWidth: 250 }}
        >
          Delete Edition bands
        </Button>
      </div>
    </PageContainer>
  );
};
